import { render, staticRenderFns } from "./ui-cascade.vue?vue&type=template&id=083fa988&scoped=true&"
import script from "./ui-cascade.vue?vue&type=script&lang=js&"
export * from "./ui-cascade.vue?vue&type=script&lang=js&"
import style0 from "./ui-cascade.vue?vue&type=style&index=0&id=083fa988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fa988",
  null
  
)

export default component.exports